import { apiWithGetHeader } from "./api";
import { API_STATUS } from "./constant";
import { BACKEND_API_BASE_URL } from "../utilities/constant";
import { getUserAccessToken } from "../utilities/setting";
import { checkAuthSession } from "../views/dashboard/auth/auth-utils";
import { API_CONTACT_GROUP_MEMBER_BY_NUMBER } from "./url";

const replacePathParam = (template, paramName, value) => {
  const encoded = encodeURIComponent(String(value ?? "").trim());
  return String(template).replace(`:${paramName}`, encoded);
};

export const getContactGroupMemberByNumber = async (number) => {
  const cleaned = String(number ?? "").trim();
  if (!cleaned) return null;

  try {
    await checkAuthSession();
    const accessToken = getUserAccessToken();
    const url = replacePathParam(API_CONTACT_GROUP_MEMBER_BY_NUMBER, "number", cleaned);

    const response = await apiWithGetHeader(BACKEND_API_BASE_URL, undefined, accessToken).get(url, {
      timeout: 30000,
    });

    if (
      response?.status === API_STATUS.SUCCESS ||
      response?.status === API_STATUS.CREATED ||
      response?.status === API_STATUS.ACCEPED
    ) {
      return response?.data?.data ?? null;
    }

    return null;
  } catch {
    return null;
  }
};

